import { render, staticRenderFns } from "./CouponSidebar.vue?vue&type=template&id=03156bfa&scoped=true&"
import script from "./CouponSidebar.vue?vue&type=script&lang=js&"
export * from "./CouponSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CouponSidebar.vue?vue&type=style&index=0&id=03156bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03156bfa",
  null
  
)

export default component.exports